var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d480c45790b030b2b590c061e6b92dee837ac169"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["knxt-frontend@knxt"]={id:"d480c45790b030b2b590c061e6b92dee837ac169"};
      